import { useEffect, useRef, useState } from 'react';

export default function useScroll() {
  const ref = useRef();
  const timer = useRef();

  const [isScrolling, setIsScrolling] = useState(false);

  function handleScroll() {
    if (timer.current) clearTimeout(timer.current);

    setIsScrolling(true);

    timer.current = setTimeout(() => {
      setIsScrolling(false);
    }, 250);
  }

  useEffect(() => {
    ref.current.addEventListener('scroll', handleScroll);

    return () => {
      if (timer.current) clearTimeout(timer.current);

      ref.current.removeEventListener('scroll', handleScroll);
    };
  }, [ref]);

  return { ref, isScrolling };
}
